import $ from 'jquery';
import App from './App';
import Tabs from './Tabs';
import 'slick-carousel/slick/slick.min.js';
import Blog from './Blog';

// eslint-disable-next-line import/prefer-default-export
export const TextInit = () => {
  App.run(() => {
    $('.cm__slick-slider').slick({
      infinite: false,
      prevArrow: '<button class="slick-prev"><i class="icon-left"></i></button>',
      nextArrow: '<button class="slick-next"><i class="icon-right"></i></button>',
      dots: true,
    });
  }, 'all', '.cm__slick-slider');

  App.run(() => {
    $(document).on('click', '.cm__questions-q', function toggleAnswearTab() {
      const self = $(this);
      const tab = self.next('.cm__questions-a');
      const className = '--expanded';
      if (self.hasClass(className)) {
        self.removeClass(className);
        tab.slideUp();
      } else {
        self.addClass(className);
        tab.slideDown();
      }
    });
  }, 'all', '.cm__questions');

  App.run(() => {
    const yt = (url) => `
      <div class="cm__iframe">
        <iframe
          width="560" 
          height="315" 
          src="${url}" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen="">
        </iframe>
      </div>
    `;
    $(document).on('click', '.cm__video', function openYtIframe(e) {
      e.preventDefault();
      const self = $(this);
      const url = self.attr('href');
      const iframe = yt(url);
      self.before(iframe);
    });
  }, 'all', '.cm__video');

  App.run(() => {
    App.vars.cmTabs = new Tabs({
      selector: '.cm__tabs-wrapp',
      destination: '.cm__tabs-dest',
    });
  }, 'all', '.cm__tabs');

  const replaceAllPolishLetters = (text = '') => text.toLowerCase().replace(/ł/g, 'l').normalize('NFKD').replace(/[^\w]/g, '');

  //FAQ SEARCH
  App.run(() => {
    $(document).on('submit', '.cm__search', function searchWordInSection(event) {
      event.preventDefault();
      const self = $(this);
      const { item: itemName, section: sectionName, tag: tagName } = self.data();

      if (!itemName || !sectionName || !tagName) return false;
      const input = self.find('.f-control');
      const filter = replaceAllPolishLetters(input.val());
      let foundSmth = false;

      $(sectionName).each(function findWordInSection() {
        const section = $(this);
        const items = section.find(itemName);
        const tag = replaceAllPolishLetters(section.find(tagName).text());
        const searchHeaderDiv = document.getElementById('searchHeaderDiv');
        let isEmpty = false;

        items.each(function findWordInSectionItem() {
          const item = $(this);
          const text = replaceAllPolishLetters(item.text());

          if (text.includes(filter) || tag.includes(filter)) {
            item.show();
            isEmpty = true;
            if (!foundSmth) {
              foundSmth = true;
              $('.cm__no-results').hide();
            }
          } else {
            item.hide();
          }
        });

        if (isEmpty || tag.includes(filter)) {
          section.show();
          // pokaż nagłówek wyniki szukania: jeśli wyraz nie jest pusty
          if (searchHeaderDiv) {
            if (filter != '') {
              searchHeaderDiv.childNodes[0]['innerHTML'] = window.Literals.text.resultHeader + ' ' + filter;
              searchHeaderDiv.classList.remove('d-none');
            } else {
              searchHeaderDiv.classList.add('d-none');
            }
          }
          if (!foundSmth) {
            foundSmth = true;
          }
        } else {
          section.hide();
          $('.cm__no-results').hide();
        }
      });
      if (!foundSmth) {
        $('.cm__no-results').show();
        searchHeaderDiv.classList.add('d-none');
      }
      // wyłącz podświetlenie litery po wyszukaniu hasła
      if (document.getElementById('alphabetLetters')) {
        Array.from(document.getElementById('alphabetLetters').children).forEach((child) => {
          child.classList.remove('--active');
        });
      }
      // pokaż wyniki
      if (document.getElementById('letterFilterResult')) {
        document.getElementById('letterFilterResult').classList.remove('d-none');
      }

      return false;
    });
  }, 'all', '.cm__search');

  App.run(() => {
    const getWords = () => {
      let ingredients = {};
      // pobranie pierwszych liter
      Object.entries(window.ingredient).forEach(([name, value]) => {
        if (Array.isArray(ingredients[name[0]])) {
          ingredients[name[0]].push(value);
        } else {
          ingredients[name[0]] = [value];
        }
      });

      // usunięcie polskich znaków z pobranych pierwszych liter
      // ingredients = Object.fromEntries(
      //   Object.entries(ingredients).map(([key, value]) => [replaceAllPolishLetters(key), value])
      // );

      // słownik z polskimi znakami
      const lang = document.getElementsByTagName("html")[0].getAttribute("lang");

      let alphabet = [];
      if (lang === 'pl') {
        alphabet = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], 'a', 'b', 'c', 'ć', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'ł', 'm', 'n', 'o', 'p', 'q', 'r', 's', 'ś', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'ź', 'ż'];
      } else {
        alphabet = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
      }
      let letter = ``;

      // stworzenie tablicy obiektów do późniejszego przyrównywania pobranych liter
      for (let i = 0; i < alphabet.length; i++) {
        if (typeof alphabet[i] === 'string') {
          alphabet[i] = {
            key: alphabet[i],
            found: false,
          };
        } else {
          alphabet[i] = {
            key: '0-9',
            found: false,
          };
        }
        // cyfry osobno + mają osobne style
        if (alphabet[i].key === '0-9') {
          letter = `<span id="letterNum" class="letter">` + alphabet[i].key + `</span>`;
        } else {
          letter = `<span id="letter` + alphabet[i].key + `" class="letter">` + alphabet[i].key.toUpperCase() + `</span>`;
        }
        document.getElementById('alphabetLetters').innerHTML += letter;
      }

      // oznaczenie znalezionych liter lub cyfr
      Object.entries(ingredients).forEach(([name]) => {
        alphabet.forEach((e) => {
          if (e.key === name.toLowerCase()) {
            e.found = true;
          }
          if (!isNaN(name)) {
            alphabet[0].found = true;
          }
        });
      });

      // dodanie klasy, która podświetli znalezione el.
      alphabet.forEach((e) => {
        if (e.key === '0-9' && e.found === true) {
          document.getElementById('alphabet').querySelector('#letterNum').classList.add("--found");
        }
        if (e.found === true && (e.key != '0-9')) {
          document.getElementById('alphabet').querySelector(`#letter${e.key}`).classList.add("--found");
        }
      });
    };
    if (document.getElementById('alphabet')) {
      if (document.getElementById('text_menu')) {
        document.getElementById('text_menu').classList.add('d-none');
      }
      getWords();
    }
  }, 'all');

  App.run(() => {
    $(document).on('click', '.letter.--found', function filterByLetter(e) {

      // pokaż litery, ukryj brak el.
      document.getElementById('letterFilterResult').classList.remove('d-none');
      if (document.getElementById('no-results')) {
        document.getElementById('no-results').style.display = 'none';
      }
      const self = $(this);
      const letter = self[0].childNodes[0].data.toLowerCase();

      $('.cm__faq').each(function findWordInSection() {
        const section = $(this);
        const items = section.find('.cm__questions-item');
        let isEmpty = false;

        items.each(function findWordInSectionItem() {
          const item = $(this);
          const text = item.text().toLowerCase();
          // z usunięciem polskich liter
          // const text = replaceAllPolishLetters(item.text());

          // pokaż wybrane, resztę ukryj
          if (text.charAt(0) == letter) {
            item.show();
            isEmpty = true;
          } else if (!isNaN(text.charAt(0)) && letter === '0-9') {
            item.show();
            isEmpty = true;
          } else {
            item.hide();
          }
        });

        if (isEmpty) {
          section.show();
        } else {
          section.hide();
        }
      });

      // podświetl wybraną literę, ew. ściągnij podświetlenie z poprzedniej
      Array.from(document.getElementById('alphabetLetters').children).forEach((child2) => {
        child2.classList.remove('--active');
      });
      this.classList.add('--active');
      // ukryj nagłówek wyniki szukania:
      document.getElementById('searchHeaderDiv').classList.add('d-none');
    });
  }, 'all');

    App.run(() => {
    const elements = document.querySelectorAll('.cm_articles.--skeleton');
    elements.forEach((element) => {
      const attributes = element.getAttributeNames().filter((el) => el.startsWith('data-'));
      const config = attributes.reduce((acc, current) => {
        const name = current.slice(5); // because data-
        const tmp_value = element.getAttribute(current);
        const value = (tmp_value === 'true' || tmp_value === 'false') ? ((tmp_value === 'true') ? true : false) : tmp_value;
        acc[name] = (name === 'articlestoshow') ? Number(value) : value;
        return acc;
      }, {});
      App.vars.cmBlog = new Blog(config, element);
    });
  }, 'all', '.cm_articles.--skeleton');
};
